import React from "react";

const DashBoardCart = () => {
  return (
    <div>
      <h1>hello dashboard cart</h1>
    </div>
  );
};

export default DashBoardCart;
